import { styled } from 'styled-components';

const StyledSettings = styled.div`
  .settings-container {
    display: flex;
    flex-direction: column;
  }

  .hidden {
    display: none;
  }

  .form-title {
    display: block;
    padding: 0;
    border-bottom: 1px solid #dfe1e1;
    padding-bottom: 0.5rem;
    margin-bottom: 0.75rem;
    font-size: 1.6rem;
    font-weight: 200;
    font-family: var(--font-stack-segoe);
    color: var(--title-color);
  }

  .displayName-form,
  .password-form,
  .delete-account,
  .email-form {
    padding: 0.25 0 2.5rem 0;
    display: flex;
    flex-direction: column;

    .PasswordContainer {
      max-width: 26rem;
    }
  }
  .displayName-form {
    padding: 0 0 2.5rem 0;
  }
  .delete-account {
    padding: 2.5rem 0 0 0;
  }

  .change-email {
    padding: 0 0 2.5rem 0;
    display: flex;
    flex-direction: column;

    .no-email-desc {
      font-size: 0.9rem;
      margin-bottom: 1rem;
    }

    .current-email {
      font-weight: bolder;
      text-size-adjust: 100%;
      margin-right: 2rem;
      margin-bottom: 0.3rem;
      margin-top: 0.75rem;
      display: flex;
      align-items: center;

      .unverified,
      .verified {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--warning);
        font-size: 0.9rem;
        font-weight: normal;
        margin-left: 1rem;

        span {
          margin-left: 0.2rem;
          margin-bottom: 0.05rem;
        }
      }

      .verified {
        color: var(--success-text);
      }
    }

    .email-group {
      display: flex;
      align-items: center;
      margin-bottom: 1.5rem;

      .unverified,
      .verified {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--warning);
        font-size: 0.9rem;

        span {
          margin-left: 0.2rem;
          margin-bottom: 0.05rem;
        }
      }

      .verified {
        color: var(--success-text);
      }
    }

    .resend {
      color: #48515b;
      margin: -0.05rem 0 0.05rem 1rem;
    }
  }

  .form-title--delete {
    font-weight: 600;
    color: #cc3232;
  }

  .Modal {
    .neutral-container {
      margin-top: 1.25rem;
      background-color: #eaeef1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 1rem;
      border-radius: 2px;

      .neutral-icon {
        line-height: 0;
        margin-right: 0.5rem;
      }

      .neutral-text {
        color: #00477a;
        font-size: 0.9rem;
        font-weight: bold;
      }
    }

    .prescriber-display {
      padding-top: 1.25rem;
      .prescriber-label {
        font-size: 0.85rem;
        color: #5a6572;
        margin-bottom: 0.4rem;
      }
    }

    .update-display {
      width: 100%;
      padding-top: 1rem;
      margin-bottom: 1rem;
      .update-label {
        font-size: 0.9rem;
        color: #5a6572;
        margin-bottom: 0.5rem;
      }
    }
    .email-modal-form {
      .email-input {
        margin-bottom: 1rem;
      }
      .password-input {
        margin-bottom: 1rem;
      }
    }

    form {
      display: flex;
      flex-direction: column;

      .form-field {
        width: 100%;
      }
    }

    .Modal__buttons {
      padding-top: 2rem;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: flex-end;

      button {
        width: auto;
      }

      .cancel {
        margin-right: 1rem;
      }
    }
  }

  .new-email-field {
    width: 100%;
  }

  /* Landscape phones/portrait tables */
  @media (max-width: 768px) {
    .form-title {
      font-size: 1.5rem;
    }
  }

  /* Landscape phones/portrait tables - smaller screen where form width breaks */
  @media (max-width: 590px) {
    .email-form {
      .email-group {
        width: 100%;
      }
    }
  }

  /* Portrait phones */
  @media (max-width: 450px) {
    .form-title {
      font-size: 1.35rem;
    }

    .settings-btn {
      margin-left: 0;
      margin-right: 0;
    }

    .changePassword-btns {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      .reset-password {
        text-align: left;
        margin: 0;
        margin-top: 1rem;
      }

      .resend {
        text-align: left;
        margin: 0;
        margin-top: 1rem;
      }
    }
  }
`;

export { StyledSettings };
